import { render, staticRenderFns } from "./LayoutRecipeDetail.vue?vue&type=template&id=10720b62&"
import script from "./LayoutRecipeDetail.vue?vue&type=script&lang=ts&"
export * from "./LayoutRecipeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutRecipeDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports